// Bairro com busca digitável (pedido do dono, 30/09/2026: "quando chego em
// BAIRROS deve ser possível escrever para buscar"). Continua escolhendo só da
// lista cadastrada — é ela que dá a taxa. Digitar filtra (sem acento e sem
// maiúscula); ↑ ↓ ou Tab andam na lista; Enter escolhe o aceso e o cursor vai
// para o próximo campo (`onEscolhido`); com um bairro já escolhido (ex.: pelo
// CEP) e a lista fechada, Enter só segue. Esc fecha a lista. Saindo do campo sem
// escolher, volta a mostrar o bairro que estava escolhido.
import { useMemo, useState } from "react";

import { Input } from "../../components/ui/input";
import { nomeDoBairro, taxaDoBairro } from "./cep";

const reais = (v) => `R$ ${Number(v || 0).toFixed(2).replace(".", ",")}`;
const sem = (s) => String(s || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().trim();

export default function BuscaBairro({ bairros, valor, onEscolher, onEscolhido, className = "" }) {
  const [texto, setTexto] = useState(null); // null = mostrando o escolhido
  const [aceso, setAceso] = useState(0);
  const [aberta, setAberta] = useState(false);
  const lista = useMemo(() => {
    const t = sem(texto);
    const todos = bairros || [];
    return t ? todos.filter((b) => sem(nomeDoBairro(b)).includes(t)) : todos;
  }, [bairros, texto]);
  const escolher = (b, e) => {
    onEscolher(b);
    setTexto(null);
    setAberta(false);
    if (onEscolhido) onEscolhido(e?.currentTarget || e?.target);
  };
  const tecla = (e) => {
    const n = lista.length;
    if ((e.key === "ArrowDown" || (e.key === "Tab" && !e.shiftKey && aberta)) && n) { e.preventDefault(); setAberta(true); setAceso((a) => (a + 1) % n); }
    else if ((e.key === "ArrowUp" || (e.key === "Tab" && e.shiftKey && aberta)) && n) { e.preventDefault(); setAberta(true); setAceso((a) => (a - 1 + n) % n); }
    else if (e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
      if (aberta && n) escolher(lista[Math.min(aceso, n - 1)], e);
      else if (valor && onEscolhido) onEscolhido(e.currentTarget); // já tem bairro: Enter segue
      else setAberta(true);
    } else if (e.key === "Escape" && aberta) { e.preventDefault(); e.stopPropagation(); setAberta(false); setTexto(null); }
  };
  return (
    <div className="relative">
      <Input
        value={texto ?? valor ?? ""} placeholder="Digite para buscar o bairro" autoComplete="off" data-e2e="busca-bairro" data-campo-endereco
        onChange={(e) => { setTexto(e.target.value); setAceso(0); setAberta(true); }}
        onFocus={(e) => e.target.select()}
        onBlur={() => setTimeout(() => { setAberta(false); setTexto(null); }, 150)}
        onKeyDown={tecla} className={className}
      />
      {aberta && (
        <div className="absolute z-50 left-0 right-0 mt-1 max-h-56 overflow-y-auto rounded-lg border bg-popover shadow-lg" data-e2e="lista-bairros">
          {lista.length === 0 && <p className="px-3 py-2 text-sm text-muted-foreground">Nenhum bairro com esse nome</p>}
          {lista.map((b, i) => (
            <button key={b.id || nomeDoBairro(b)} type="button" data-e2e="bairro-opcao"
              onMouseDown={(e) => { e.preventDefault(); escolher(b, { target: e.currentTarget.closest(".relative")?.querySelector("input") }); }}
              onMouseEnter={() => setAceso(i)}
              className={`w-full px-3 py-2 text-sm flex justify-between gap-3 text-left ${i === aceso ? "bg-orange-500/15" : "hover:bg-muted"} ${nomeDoBairro(b) === valor ? "font-semibold" : ""}`}>
              <span className="truncate">{nomeDoBairro(b)}</span>
              <span className="text-muted-foreground shrink-0">{reais(taxaDoBairro(b))}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
